<template>
  <div
    v-if="seoContent?.copyBlock"
    id="searchGoogleAdsense"
  >
    <CopyBlock
      v-if="showCopy"
      :copy-block="seoContent?.copyBlock"
    />
  </div>
  <div
    v-if="seoContent?.tagCloud"
    class="seo-tag-wrapper"
    :class="{addTagTopPadding: showCopy}"
  >
    <TagCloud :tag-cloud="seoContent?.tagCloud" />
  </div>
</template>

<script setup>
import { defineAsyncComponent } from 'vue';
import CopyBlock from './CopyBlock';

const TagCloud = defineAsyncComponent(() => import('./TagCloud'));

defineProps({
  seoContent: {
    type: Object,
    default: () => ({}),
  },
  showCopy: {
    type: Boolean,
    default: true,
  },
});

</script>

<style lang="scss" scoped>
@import '~@core/foundation/scss/foundation-6.7.4/scss/prototype/_spacing.scss';
.seo-tag-wrapper {
  @include margin-direction('bottom', map-get($spacer, 'xl'));
}
.addTagTopPadding {
    padding-top: 48px;
  }
</style>

<style lang="scss" brand="bcom" scoped>
@import '~@core/foundation/scss/foundation-6.7.4/scss/prototype/_spacing.scss';
.seo-tag-wrapper {
  @include breakpoint(large) {
    @include margin-direction('bottom', map-get($spacer, 'xxl'));
  }
}
</style>
